var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.416 13.044V8h-5.84C4.715 8.09 1 9.22 1 13.044c0 4.78 6.106 6.106 7.7 6.106 1.592 0 4.512 3.452 1.592 4.78-2.92 1.327-5.31-.266-6.372-1.328-.85-.85-1.947-2.832-2.39-3.717v5.84h10.09c.884-.707 2.601-2.601 2.389-4.513-.267-2.39-3.187-5.044-5.31-5.31-2.125-.265-4.78-1.722-4.78-3.982 0-2.26 4.248-2.787 6.372-1.593 1.7.956 2.124 2.877 2.124 3.717zm2.39 11.682 2.123-2.124V10.124L14.804 8h9.558a4.936 4.936 0 0 1 3.982 4.248c.425 2.973-2.478 4.248-3.982 4.513l5.575 7.17 1.062.796h-5.31l-4.778-7.965-.797.798v5.044l1.593 2.124h-6.903zm5.84-8.761V9.327c.13.01.28.011.445.012 1.307.008 3.538.023 3.538 4.5 0 2.262-2.23 2.183-3.535 2.136-.166-.006-.317-.011-.447-.011z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRare);
export default __webpack_public_path__ + "static/media/RARE.001865d6a2799ab1ef66cfe9f0354bd5.svg";
export { ForwardRef as ReactComponent };